export class AppConstants {
  public static organization = 'Organization';
  public static location = 'Location';
  public static userPreferencesQuestionnaireIdentifier = 'User-Preferences';
  public static organizationTypeCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthOrganizationTypeCS';
  public static organizationFacilitySystem = 'https://fhir.infoway-inforoute.ca/NamingSystem/ca-on-hospital-id';
  public static organizationSiteSystem = 'https://fhir.infoway-inforoute.ca/NamingSystem/ca-on-health-care-facility-id';
  public static userRoleSystem = 'https://corhealth-ontario.ca/user-role';
  public static entrySystemForService = 'https://corhealth-ontario.ca/entry/system';
  public static physicianSystem = 'https://fhir.infoway-inforoute.ca/NamingSystem/ca-on-license-physician';
  public static mrnIssuerSystem = 'https://corhealth-ontario.ca/fhir/StructureDefinition/ca-on-mrn-system-uri';
  public static cardiacTypeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthOrganizationTypeServiceCS';
  public static cardiacTypeValue = '01';
  public static expirePeriodSystem = 'http://hl7.org/fhir/StructureDefinition/organization-period';
  public static dataAbsentReasonSystem = 'http://terminology.hl7.org/CodeSystem/data-absent-reason';
  public static pcrEidIdentifierNamingSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-pcr-eid';
  public static errorCodes = {client: [0], pcr: [400, 403, 415, 500, 404, 422]};
  public static ontarioHcnIssuerNamingSystem = 'https://fhir.infoway-inforoute.ca/NamingSystem/ca-on-patient-hcn';
  public static MohHcnIssuerNamingSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-registration-and-claims-branch-def-source';
  public static referralServiceDetail2 = 'referral-service-detail-2';
  public static acceptanceServiceDetail2 = 'acceptance-service-detail-2';
  public static diagnosticsServiceDetail2 = 'diagnostics-service-detail-2';
  public static addableAcceptanceFields = ['dates-affecting-readiness-to-treat', 'cancellations-and-bookings'];
  public static addableOfflistingFields = ['stent'];
  public static DARTFieldLinkId = 'dates-affecting-readiness-to-treat';
  public static bookingFieldLinkId = 'cancellations-and-bookings';
  public static bookingDateFieldLinkId = 'cancellations-and-bookings-booking-date';
  public static removalDateFieldLinkId = 'removal-date';
  public static dynamicPractitionerFields = ['referring-physician', 'treating-health-care-professional',
    'responsible-health-care-professional', 'second-treating-health-care-professional'];
  public static OffListingProcedureHCPLinkId = 'treating-health-care-professional';
  public static OffListingProcedureSecondHCPLinkId = 'second-treating-health-care-professional';

  public static dynamicSiteFields = ['wait-location', 'non-percutaneous-coronary-intervention-capable-hospital'];
  public static diagnosticserviceLocation = 'diagnostics-service-location';
  public static offlistingServiceLocation = 'offlisting-service-location';
  public static diagnosticsPrimaryReferralType = 'diagnostics-primary-referral-type';
  public static diagnosticSecondaryReferralType = 'diagnostics-secondary-referral-type';
  public static serviceDetail2ForDiagnosticVariations = 'CORANG';
  public static serviceDetail2ForCtrp = 'CRTP';
  public static serviceLocationLinkId = 'service-location';
  public static serviceDetail2Label = 'Service Detail 2';
  public static serviceDetail2LinkId = 'service-detail-2';
  public static serviceCodeLinkId = 'service-code';
  public static primaryReasonReferralLinkId = 'primary-reason-referral';
  public static primaryReasonReferralTypeLabel = 'Primary Reason for Referral Type';
  public static secondaryReasonReferralTypeLabel = 'Secondary Reason for Referral Type';
  public static primaryReasonReferralTypeLinkId = 'primary-referral-type';
  public static secondaryReasonReferralLinkId = 'secondary-reason-referral';
  public static secondaryReasonReferralTypeLinkId = 'secondary-referral-type';
  public static numericRangeIncludingUnknown = ['serum-creatinine', 'diagnostic-weight', 'diagnostic-height'];
  public static allProceduresLinkId = 'procedure-all';
  public static procedureServiceDetail1LinkId = 'procedure-service-detail-1-1';
  public static procedureServiceDetail2LinkId = 'procedure-service-detail-1-2';
  public static procedureServiceDetail3LinkId = 'procedure-service-detail-1-3';
  public static procedureServiceDetail4LinkId = 'procedure-service-detail-1-4';
  public static codeForSTEMI = 'ST';
  public static codeForNSTEMI = 'NS';
  public static firstBalloonInflationDeviceLinkId = 'first-balloon-inflation-device-datetime';
  public static nonPercutaneousHospitalLinkId = 'non-percutaneous-coronary-intervention-capable-hospital';
  public static firstContactParamedicsLinkId = 'first-contact-with-paramedics-datetime';
  public static ambulanceEcgLinkId = 'ambulance-electrocardiogram-datetime';
  public static registrationDateLinkId = 'registration-datetime';
  public static firstHospitalEcgLinkId = 'first-hospital-electrocardiogram-datetime';
  public static fibrinolysisGivenLinkId = 'fibrinolysis-given-datetime';
  public static patientPresentationLinkId = 'patient-presentation';
  public static fibrinolysisAdministeredLinkId = 'fibrinolysis-administered';
  public static historyofCoronaryArteryBypassLinkId = 'history-of-coronary-artery-bypass-graft-surgery';
  public static historyofCoronaryArteryBypassLabel = 'History of Coronary Artery Bypass Graft Surgery';
  public static removalReasonLinkId = 'removal-reason';
  public static condition1 = ['AN', 'SN'];
  public static condition2 = ['AD', 'AP', 'AN'];
  public static condition3Not = ['IP'];
  public static condition4 = ['AD'];
  public static selfTransport = ['SP', 'SN'];
  public static entryCategoryLinkId = 'service-category';
  public static serviceAreaLinkId = 'service-area';
  public static serviceDetail1LinkId = 'service-detail-1';
  public static dashboardServiceAreaLinkId = 'dashboard-service-area';
  public static dashboardServiceDetail1LinkId = 'dashboard-service-detail-1';
  public static dashboardServiceDetail2LinkId = 'dashboard-service-detail-2';
  public static dashboardHCPLinkId = 'responsible-health-care-professional';
  public static warningOnsetFocusFields = ['service-area', 'service-location', 'service-detail-1', 'service-detail-2',
    'primary-reason-referral', 'secondary-reason-referral', 'patient-presentation', 'fibrinolysis-administered',
    'procedure-all', 'procedure-status', 'presence-of-coronary-stenosis'];
  public static warningOnsetCoronaryArteryBypassValues = ['N', 'U', 'Y'];
  // tslint:disable-next-line: max-line-length
  public static repeatableProceduralSubsection = ['offlisting-history-of-coronary-artery-bypass-graft-surgery', 'removal-date', 'removal-reason', 'offlisting-primary-referral-type'];
  public static offlistingSubsectionLastFieldLinkId = 'vascular-complication';
  public static procedureStatusLinkId = 'procedure-status';
  public static removalReasonValidationFields = ['cancellations-and-bookings-booking-date',
    'cancellations-and-bookings-cancellation-reason', 'removal-date', 'removal-reason', 'acceptance-date'];
  public static PCIForCoronaryAngiogram = ['SSPCI', 'PPCI', 'RPCI', 'PHPCI', 'LPCI'];
  public static closedEntryExclusions = ['cancellations-and-bookings-cancellation-reason', 'dates-affecting-readiness-to-treat',
    'delay-reason', 'clinical-status-change-date'];
  public static proceduresCoronaryAngiogram = 'CORANG';
  public static PCIForEPSTDY = ['STDABL', 'CPXABL'];
  public static proceduresElectrophysiologyStudy= 'EPSTDY';
  public static codeProcedureSSPCI = 'SSPCI';
  public static proceduresCompleted = 'C';
  public static removalReasonDataError = 'ER';
  public static waitTimeNARemovalReasons = ['ER', 'NP', 'PD'];
  public static removalReasonProcedureStarted = 'PS';
  public static removalReasonFieldLinkId = 'removal-reason';
  public static offlistingHistoryofCoronaryArteryBypass = 'offlisting-history-of-coronary-artery-bypass-graft-surgery';
  public static offlistingPrimaryReferralType = 'offlisting-primary-referral-type';
  public static dashboardFilterNoRMWTServiceDetail2List = ['Coronary Angiogram',
    'Staged Percutaneous Coronary Intervention',
    'Scheduled Percutaneous Coronary Intervention',
    'Single Chamber Implantable Cardioverter Defibrillator',
    'Dual Chamber Implantable Cardioverter Defibrillator',
    'Cardiac Resynchronization Therapy Implantable Cardioverter Defibrillator',
    'Coronary Artery Bypass Graft Surgery'
  ];
  public static patientPhoneTypes = ['Home', 'Mobile', 'Work'];
  public static patientAddressTypes = ['Home', 'Mailing', 'Temporary'];
  public static sectionLinkId = [AppConstants.referralServiceDetail2, AppConstants.diagnosticsServiceDetail2,
    AppConstants.diagnosticsPrimaryReferralType, AppConstants.diagnosticSecondaryReferralType,
    AppConstants.offlistingPrimaryReferralType, AppConstants.offlistingHistoryofCoronaryArteryBypass
  ];
  public static entryStatusLinkId = 'entry-status';

  public static defaultHomePageLinkId = 'default-home-page';
  public static dashUISymbol = '–';
  public static raceBlackLinkId = 'race-black';
  public static raceNotCollectedLinkId = 'race-not-collected';
  public static raceUnknownLinkId = 'race-unknown';
  public static racePreferNotAnswerLinkId = 'race-prefer-not-to-answer';
  public static stenosisLinkIdsPrefix = 'stenosis-of-';
  public static presenceOfStenosisLinkId = 'presence-of-coronary-stenosis';
  public static stenosisGraftIds = ['stenosis-of-the-left-anterior-descending-artery-graft',
    'stenosis-of-the-circumflex-artery-graft', 'stenosis-of-the-right-coronary-artery-graft'];
  public static specialCharacterRestriction = '^[^-%&~^|\\\\]*$';
  public static deviceIndicationLinkId = 'device-indication';
  public static fhirFetchBatchSize = 4000;
  public static clinicalStatusChangeDateLinkId = 'clinical-status-change-date';
  public static observationCodeSystemUri = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthDataElementObservationCS';
  public static historyOfMyocardialInfarctionLinkId = 'history-of-myocardial-infarction';
  public static canadianCardiovascularSocietyClassificationLinkId = 'canadian-cardiovascular-society-classification';
  public static acuteCoronarySyndromeClassificationLinkId = 'acute-coronary-syndrome-classification';
  public static cardiogenicShockLinkId = 'cardiogenic-shock';
  public static newYorkHeartAssociationFunctionalClassificationLinkId = 'new-york-heart-association-functional-classification';
  public static restElectrocardiogramIschemicChangesLinkId = 'rest-electrocardiogram-ischemic-changes';
  public static exerciseElectrocardiogramRiskLinkId = 'exercise-electrocardiogram-risk';
  public static functionalImagingRiskLinkId = 'functional-imaging-risk';
  public static leftVentricularEjectionFractionLinkId = 'left-ventricular-ejection-fraction';
  public static leftVentricularEjectionFractionGradeLinkId = 'left-ventricular-ejection-fraction-grade';
  public static serumCreatinineLinkId = 'serum-creatinine';
  public static dialysisLinkId = 'dialysis';
  public static diabetesLinkId = 'diabetes';
  public static historyOfTobaccoUseLinkId = 'history-of-tobacco-use';
  public static cerebralVascularDiseaseLinkId = 'cerebral-vascular-disease';
  public static chronicObstructivePulmonaryDiseaseLinkId = 'chronic-obstructive-pulmonary-disease';
  public static historyOfCoronaryArteryBypassGraftSurgeryLinkId = 'history-of-coronary-artery-bypass-graft-surgery';
  public static endocarditisLinkId = 'endocarditis';
  public static historyOfCongestiveHeartFailureLinkId = 'history-of-congestive-heart-failure';
  public static diagnosticHeightLinkId = 'diagnostic-height';
  public static diagnosticWeightLinkId = 'diagnostic-weight';
  public static preProceduralMitralRegurgitationLinkId = 'pre-procedural-mitral-regurgitation';
  public static mitralRegurgitationTypeLinkId = 'mitral-regurgitation-type';
  public static mitralValveOrificeAreaLinkId = 'mitral-valve-orifice-area';
  public static pulmonaryArterySystolicPressureLinkId = 'pulmonary-artery-systolic-pressure';
  public static leftMainLesionWithoutBypassGraftLinkId = 'left-main-lesion-without-bypass-graft';
  public static threeVesselDiseaseWithProximalLeftAnteriorDescendingArteryLinkId =
    'three-vessel-disease-with-proximal-left-anterior-descending-artery';
  public static veinGraftLesionLinkId = 'vein-graft-lesion';
  public static survivalDependentVesselLinkId = 'survival-dependent-vessel';
  public static nativeStenosisOfTheLeftMainArteryLinkId = 'native-stenosis-of-the-left-main-artery';
  public static nativeStenosisOfTheProximalLeftAnteriorDescendingArteryLinkId =
    'native-stenosis-of-the-proximal-left-anterior-descending-artery';
  public static nativeStenosisOfTheMidDistalLeftAnteriorDescendingArteryLinkId =
    'native-stenosis-of-the-mid-Distal-left-anterior-descending-artery';
  public static nativeStenosisOfTheCircumflexArteryLinkId = 'native-stenosis-of-the-circumflex-artery';
  public static nativeStenosisOfTheRightCoronaryArteryLinkId = 'native-stenosis-of-the-right-coronary-artery';
  public static stenosisOfTheLeftAnteriorDescendingArteryGraftLinkId = 'stenosis-of-the-left-anterior-descending-artery-graft';
  public static stenosisOfTheCircumflexArteryGraftLinkId = 'stenosis-of-the-circumflex-artery-graft';
  public static stenosisOfTheRightCoronaryArteryGraftLinkId = 'stenosis-of-the-right-coronary-artery-graft';
  public static implantStatusLinkId = 'implant-status';
  public static qualifyingElectrocardiogramDatetimeLinkId = 'qualifying-electrocardiogram-datetime';
  public static heartTeamInvolvedInTreatmentDecisionLinkId = 'heart-team-involved-in-treatment-decision';
  public static fundingSourceLinkId = 'funding-source';
  public static datesAffectingReadinessToTreatFromDateLinkId = 'dates-affecting-readiness-to-treat-from-date';
  public static datesAffectingReadinessToTreatToDateLinkId = 'dates-affecting-readiness-to-treat-to-date';
  public static delayReasonLinkId = 'delay-reason';
  public static cancellationsAndBookingsCancellationReasonLinkId = 'cancellations-and-bookings-cancellation-reason';
  public static responsibleHealthCareProfessionalLinkId = 'responsible-health-care-professional';
  public static acceptanceDateLinkId = 'acceptance-date';
  public static accessSiteLinkId = 'access-site';
  public static performerCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthPerformerRoleCS';
  public static treatingHealthCareProfessionalLabel = 'Treating Health Care Professional';
  public static secondTreatingHealthCareProfessionalLabel = 'Second Treating Health Care Professional';
  public static treatingHealthCareProfessionalCode = 'T1';
  public static secondTreatingHealthCareProfessionalCode = 'T2';
  public static intraAorticBalloonPumpLinkId = 'intra-aortic-balloon-pump';
  public static stenosisOfTheLeftMainArteryLinkId = 'stenosis-of-the-left-main-artery';
  public static stenosisOfTheProximalLeftAnteriorDescendingArteryLinkId = 'stenosis-of-the-proximal-left-anterior-descending-artery';
  public static stenosisOfTheMidDistalLeftAnteriorDescendingArteryLinkId = 'stenosis-of-the-mid-distal-left-anterior-descending-artery';
  public static stenosisOfTheCircumflexArteryLinkId = 'stenosis-of-the-circumflex-artery';
  public static stenosisOfTheRightCoronaryArteryLinkId = 'stenosis-of-the-right-coronary-artery';
  public static stentDeploymentLocationLinkId = 'stent-lesion-location';
  public static stentTypeLinkId = 'stent-device-type';
  public static stentSizeLinkId = 'stent-size';
  public static stentLengthLinkId = 'stent-length';
  public static lesionTypeLinkId = 'stent-lesion-type';
  public static ChronicTotalOcclusionResultLinkId = 'stent-chronic-total-occlusion-result';
  public static extracorporealCardiopulmonaryBypassLinkId = 'extracorporeal-cardiopulmonary-bypass';
  public static valveSurgeryTypeLinkId = 'valve-surgery-type';
  public static atrialFibrillationAblationTypeLinkId = 'atrial-fibrillation-ablation-type';
  public static atrialFibrillationAblationInstanceLinkId = 'atrial-fibrillation-ablation-instance';
  public static clinicallyRelevantPericardialEffusionLinkId = 'clinically-relevant-pericardial-effusion';
  public static deviceEmbolizationLinkId = 'device-embolization';
  public static majorBleedingLinkId = 'major-bleeding';
  public static numberOfValveClipsLinkId = 'number-of-valve-clips';
  public static postOperativeMitralRegurgitationLinkId = 'post-operative-mitral-regurgitation';
  public static postOperativeMitralValveGradientLinkId = 'post-operative-mitral-valve-gradient';
  public static persistentInterAtrialShuntPostProcedureLinkId = 'persistent-inter-atrial-shunt-post-procedure';
  public static technicalSuccessLinkId = 'technical-success';
  public static vascularComplicationLinkId = 'vascular-complication';
  public static raceLinkId = 'race';
  public static waitLocationLinkId = 'wait-location';
  public static recommendedMaximumWaitTimeLinkId = 'recommended-maximum-wait-time';
  public static waitTime1LinkId = 'wait-time-1';
  public static waitTime2LinkId = 'wait-time-2';
  public static priorityLevelLinkId = 'priority-level';
  public static urgencyRatingScoreLinkId = 'urgency-rating-score';
  public static calculationAnatomyResultLinkId = 'calculation-anatomy-result';
  public static calculationCsLinkId = 'calculation-cs';
  public static calculationCcLinkId = 'calculation-cc';
  public static calculationCiLinkId = 'calculation-ci';
  public static calculationCaLinkId = 'calculation-ca';
  public static calculationCvLinkId = 'calculation-cv';
  public static calculationCmLinkId = 'calculation-cm';
  public static calculationCpLinkId = 'calculation-cp';
  public static waitTime1DartDaysLinkId = 'dart-days-wait-time-1';
  public static waitTime2DartDaysLinkId = 'dart-days-wait-time-2';
  public static loincCodeSystemUri = 'http://loinc.org';
  public static codeValueForDiagnosticReport = '34133-9';
  public static codeDisplayForDiagnosticReport = 'Summary of episode note';
  public static codeValueForProcedureDiagnosticReport = '85938-9';
  public static codeDisplayForProcedureDiagnosticReport = 'Cardiology Postoperative evaluation and management note';
  public static cancellationReasonCodeSystem =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth111CancellationReasonCS';
  public static procedureCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth114ProcedureCS';
  public static accessSiteCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth116AccessSiteCS';
  public static serviceDetailCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth23ServiceDetailCS';
  public static heartTeamInvolvedInTreatmentDecisionLabel = 'Heart Team Involved in Treatment Decision';
  public static fundingSourceLabel = 'Funding Source';
  public static datesAffectingReadinessToTreatFromDateLabel = 'Dates Affecting Readiness to Treat From Date (YYYY-MM-DD)';
  public static datesAffectingReadinessToTreatToDateLabel = 'Dates Affecting Readiness to Treat To Date (YYYY-MM-DD)';
  public static delayReasonsLabel = 'Delay Reason(s)';
  public static heightLabel = 'Height (cm)';
  public static weightLabel = 'Weight (kg)';
  public static clinicalStatusChangeDateLabel = 'Clinical Status Change Date';
  public static historyOfMyocardialInfarctionLabel = 'History of Myocardial Infarction';
  public static canadianCardiovascularSocietyClassificationLabel = 'Canadian Cardiovascular Society Classification';
  public static acuteCoronarySyndromeClassificationLabel = 'Acute Coronary Syndrome Classification';
  public static referralDateLinkId = 'referral-date';
  public static referringPhysicianLinkId = 'referring-physician';
  public static indigenousRaceLinkId = 'race-indigenous';
  public static indigenousRaceDisplayValue = 'Indigenous (First Nations, Métis, Inuk/Inuit)';
  public static procedureFHIRStatusCompleted = 'completed';
  public static procedureFHIRStatusNotDone = 'not-done';
  public static procedureStatusCompletedCode = 'C';
  public static procedureStatusNotDoneCode = 'N';
  public static stentObservationCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthDataElementObservationDeviceCS';
  public static stentObservationsCodeValue = '127-131_177';
  public static stentObservationsCodeDisplay = 'Stent Information';
  public static stentDeploymentLocationCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth127LesionLocationCS';
  public static lesionTypeCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth128LesionTypeCS';
  public static stentTypeCodeSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth129DeviceTypeCS';
  public static stentDeploymentLocationWithoutIndexLinkId = 'stent-lesion-location';
  public static serviceCategorySiteService = 27;
  public static serviceTypeSiteServiceSystem = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth23ServiceDetailCS';
  // tslint:disable-next-line: max-line-length
  public static serviceExtensionPeriodSystem = 'https://corhealth-ontario.ca/fhir/StructureDefinition/corhealth-healthcareservice-period-ext';
  public static UNKNOWN_ENTRY_VALUE_TEXT = 'Unknown';
  public static UNKNOWN_ENTRY_VALUE_CODE = 'U';
  public static NOT_APPLICABLE_ENTRY_VALUE = 'X';
  public static UNKNOWN_CLINICAL_VALUE = 'unknown';
  public static NOT_APPLICABLE_CLINICAL_VALUE = 'not-applicable';
  public static NOT_APPLICABLE_DISPLAY_VALUE = 'Not Applicable';
  public static DATA_ABSENT_REASON_CODE_SYSTEM = 'http://terminology.hl7.org/CodeSystem/data-absent-reason';

  public static ENTRY_VALUE_YES = 'Y';
  public static ENTRY_VALUE_NO = 'N';

  public static QUERY_STRING_PARAM_COUNT_VALUE = 4000;
  public static PRIORITY_LEVEL_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth31PriorityLevelCS';
  public static RACE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth153RaceCS';
  public static REFERRAL_REASON_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth38ReasonForReferralCS';
  public static REFERRAL_REASON_TYPE_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth39ReasonForReferralTypeCS';
  public static REMOVAL_REASON_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth113RemovalReasonCS';
  public static DELAY_REASON_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth152DelayReasonCS';
  public static FUNDING_SOURCE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth107FundingSourceCS';
  public static PRESENCE_OF_CORONARY_STENOSIS_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth118PresenceCoronaryStenosisCS';
  public static STENOSIS_OF_THE_LEFT_MAIN_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth119LeftMainArteryStenosisCS';
  public static STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth120StenosisProximalLeftAnteriorDescendingArteryCS';
  public static STENOSIS_OF_THE_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth121StenosisMidDistalLeftAnteriorDescendingArteryCS';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth122StenosisCircumflexArteryCS';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth123StenosisRightCoronaryArteryCS';
  public static STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_124_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth124StenosisLeftAnteriorDescendingArteryGraftCS';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_125_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth125StenosisCircumflexArteryGraftCS';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_126_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth126StenosisRightCoronaryArteryGraftCS';
  public static EXTRACORPOREAL_CARDIOPULMONARY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth134ExtracorporealCardiopulmonaryBypassCS';
  public static VALVE_SURGERY_TYPE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth135ValveSurgeryTypeCS';
  public static ATRIAL_FIBRILLATION_ABLATION_TYPE_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth136AtrialFibrillationAblationTypeCS';
  public static ATRIAL_FIBRILLATION_ABLATION_INSTANCE_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth137AtrialFibrillationAblationInstanceCS';
  public static POST_OPERATIVE_MITRAL_REGURGITATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth142PostOperativeMitralRegurgitationCS';
  public static STENT_DEPLOYMENT_LOCATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth127LesionLocationCS';
  public static LESION_TYPE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth128LesionTypeCS';
  public static STENT_TYPE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth129DeviceTypeCS';
  public static CHRONIC_TOTAL_OCCLUSION_RESULT_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth177ChronicTotalOcclusionResultCS';
  public static HISTORY_OF_MYOCARDIAL_INFARCTION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealthData43HistoryMyocardialInfarctionCS';
  public static CANADIAN_CARDIOVASCULAR_SOCIETY_CLASSIFICATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth44CanadianCardiovascularSocietyClassCS';
  public static ACUTE_CORONARY_SYNDROME_CLASSIFICATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth45AcuteCoronarySyndromeClassificationCS';
  public static NEW_YORK_HEART_ASSOCIATION_FUNCTIONAL_CLASSIFICATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth47NewYorkHeartAssociationFunctionalClassCS';
  public static REST_ELECTROCARDIOGRAM_ISCHEMIC_CHANGES_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth48RestElectrocardiogramIschemicChangesCS';
  public static EXERCISE_ELECTROCARDIOGRAM_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth49ExerciseElectrocardiogramRiskCS';
  public static FUNCTIONAL_IMAGING_RISK_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth50FunctionalImagingRiskCS';
  public static LEFT_VENTRICULAR_EJECTION_FRACTION_GRADE_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth52LeftVentricularEjectionFractionGradeCS';
  public static HISTORY_OF_TOBACCO_USE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth57HistoryTobaccoUseCS';
  public static ENDOCARDITIS_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth61EndocarditisCS';
  public static PRE_PROCEDURAL_MITRAL_REGURGITATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth67PreProceduralMitralRegurgitationCS';
  public static MITRAL_REGURGITATION_TYPE_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth68MitralRegurgitationTypeCS';
  public static NATIVE_STENOSIS_OF_THE_LEFT_MAIN_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth75NativeStenosisLeftMainArteryCS';
  public static NATIVE_STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth76NativeStenosisProximalLeftAnteriorDescendingArteryCS';
  public static NATIVE_STENOSIS_OF_THE_PROXIMAL_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth77NativeStenosisMidDistalLeftAnteriorDescendingArteryCS';
  public static NATIVE_STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth78NativeStenosisCircumflexArteryCS';
  public static NATIVE_STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth79NativeStenosisRightCoronaryArteryCS';
  public static STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth80StenosisLeftAnteriorDescendingArteryGraftCS';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth81StenosisCircumflexArteryGraftCS';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth82StenosisRightCoronaryArteryGraftCS';
  public static IMPLANT_STATUS_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth83ImplantStatusCS';
  public static DEVICE_INDICATION_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth84DeviceIndicationCS';
  public static PATIENT_PRESENTATION_CODE_SYSTEM = 'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth85PatientPresentationCS';
  public static FIBRINOLYSIS_ADMINISTERED_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/CorHealth88FibrinolysisAdministeredCS';

  public static VALUE_TYPE_BOOLEAN = 'valueBoolean';
  public static VALUE_TYPE_CODEABLE_CONCEPT = 'valueCodeableConcept';
  public static VALUE_TYPE_DATETIME = 'valueDateTime';
  public static VALUE_TYPE_INTEGER = 'valueInteger';
  public static VALUE_TYPE_PERIOD = 'valuePeriod';
  public static VALUE_TYPE_QUANTITY = 'valueQuantity';
  public static VALUE_TYPE_STRING = 'valueString';

  public static RACE_BLACK = 'Black';
  public static RACE_EAST_SOUTHEAST_ASIAN = 'East/Southeast Asian';
  public static RACE_INDIGENOUS = 'Indigenous (First Nations, Métis, Inuk/Inuit)';
  public static RACE_LATINO = 'Latino';
  public static RACE_MIDDLE_EASTERN = 'Middle Eastern';
  public static RACE_SOUTH_ASIAN = 'South Asian';
  public static RACE_WHITE = 'White';
  public static RACE_OTHER = 'Other';
  public static RACE_UNKNOWN = 'Unknown';
  public static RACE_PREFER_NOT_TO_ANSWER = 'Prefer Not to Answer';
  public static RACE_NOT_COLLECTED = 'Not Collected';

  public static RACE_BLACK_CLINICAL_VALUE = 'B';
  public static RACE_EAST_SOUTHEAST_ASIAN_CLINICAL_VALUE = 'A';
  public static RACE_INDIGENOUS_CLINICAL_VALUE = 'I';
  public static RACE_LATINO_CLINICAL_VALUE = 'L';
  public static RACE_MIDDLE_EASTERN_CLINICAL_VALUE = 'M';
  public static RACE_SOUTH_ASIAN_CLINICAL_VALUE = 'S';
  public static RACE_WHITE_CLINICAL_VALUE = 'W';
  public static RACE_OTHER_CLINICAL_VALUE = 'O';
  public static RACE_PREFER_NOT_TO_ANSWER_CLINICAL_VALUE = 'P';
  public static RACE_NOT_COLLECTED_CLINICAL_VALUE = 'N';

  public static DELAY_REASON_RESOURCING = 'Resourcing';
  public static DELAY_REASON_URGENT_PATIENT = 'Urgent Patient';
  public static DELAY_REASON_EQUIPMENT_FAILURE = 'Equipment Failure';
  public static DELAY_REASON_OTHER = 'Other';

  public static DELAY_REASON_RESOURCING_CLINICAL_VALUE = 'RE';
  public static DELAY_REASON_URGENT_PATIENT_CLINICAL_VALUE = 'UP';
  public static DELAY_REASON_EQUIPMENT_FAILURE_CLINICAL_VALUE = 'EF';
  public static DELAY_REASON_OTHER_CLINICAL_VALUE = 'OT';

  public static RMWT_OBSERVATION_CODE = '28';
  public static WAIT_TIME_1_OBSERVATION_CODE = '29';
  public static WAIT_TIME_2_OBSERVATION_CODE = '30';
  public static PRIORITY_LEVEL_OBSERVATION_CODE = '31';
  public static URS_OBSERVATION_CODE = '32';
  public static SECONDARY_REFERRAL_REASON_OBSERVATION_CODE = '40';
  public static SECONDARY_REFERRAL_REASON_TYPE_OBSERVATION_CODE = '41';
  public static CLINICAL_STATUS_CHANGE_DATE_OBSERVATION_CODE = '42';
  public static HISTORY_OF_MYOCARDIAL_INFARCTION_OBSERVATION_CODE = '43';
  public static CANADIAN_CARDIOVASCULAR_SOCIETY_CLASSIFICATION_OBSERVATION_CODE = '44';
  public static ACUTE_CORONARY_SYNDROME_CLASSIFICATION_OBSERVATION_CODE = '45';
  public static CARDIOGENIC_SHOCK_OBSERVATION_CODE = '46';
  public static NEW_YORK_HEART_ASSOCIATION_FUNCTIONAL_CLASSIFICATION_OBSERVATION_CODE = '47';
  public static REST_ELECTROCARDIOGRAM_ISCHEMIC_CHANGES_OBSERVATION_CODE = '48';
  public static EXERCISE_ELECTROCARDIOGRAM_OBSERVATION_CODE = '49';
  public static FUNCTIONAL_IMAGING_RISK_OBSERVATION_CODE = '50';
  public static LEFT_VENTRICULAR_EJECTION_FRACTION_OBSERVATION_CODE = '51';
  public static LEFT_VENTRICULAR_EJECTION_FRACTION_GRADE_OBSERVATION_CODE = '52';
  public static SERUM_CREATININE_OBSERVATION_CODE = '53';
  public static DIALYSIS_OBSERVATION_CODE = '55';
  public static DIABETES_OBSERVATION_CODE = '56';
  public static HISTORY_OF_TOBACCO_USE_OBSERVATION_CODE = '57';
  public static CEREBRAL_VASCULAR_DISEASE_OBSERVATION_CODE = '58';
  public static CHRONIC_OBSTRUCTIVE_PULMONARY_DISEASE_OBSERVATION_CODE = '59';
  public static HISTORY_OF_CORONARY_ARTERY_BYPASS_GRAFT_SURGERY_OBSERVATION_CODE = '60';
  public static ENDOCARDITIS_OBSERVATION_CODE = '61';
  public static HISTORY_OF_CONGESTIVE_HEART_FAILURE_OBSERVATION_CODE = '62';
  public static HEIGHT_OBSERVATION_CODE = '63';
  public static WEIGHT_OBSERVATION_CODE = '65';
  public static PRE_PROCEDURAL_MITRAL_REGURGITATION_OBSERVATION_CODE = '67';
  public static MITRAL_REGURGITATION_TYPE_OBSERVATION_CODE = '68';
  public static MITRAL_VALVE_ORIFICE_AREA_OBSERVATION_CODE = '69';
  public static PULMONARY_ARTERY_SYSTOLIC_PRESSURE_OBSERVATION_CODE = '70';
  public static LEFT_MAIN_LESION_WITHOUT_BYPASS_GRAFT_OBSERVATION_CODE = '71';
  public static THREE_VESSEL_DISEASE_OBSERVATION_CODE = '72';
  public static VEIN_GRAFT_LESION_OBSERVATION_CODE = '73';
  public static SURVIVAL_DEPENDENT_VESSEL_OBSERVATION_CODE = '74';
  public static NATIVE_STENOSIS_OF_THE_LEFT_MAIN_ARTERY_OBSERVATION_CODE = '75';
  public static NATIVE_STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE = '76';
  public static NATIVE_STENOSIS_OF_THE_PROXIMAL_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE = '77';
  public static NATIVE_STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_OBSERVATION_CODE = '78';
  public static NATIVE_STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_OBSERVATION_CODE = '79';
  public static STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_OBSERVATION_CODE = '80';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_OBSERVATION_CODE = '81';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_OBSERVATION_CODE = '82';
  public static IMPLANT_STATUS_OBSERVATION_CODE = '83';
  public static DEVICE_INDICATION_OBSERVATION_CODE = '84';
  public static PATIENT_PRESENTATION_OBSERVATION_CODE = '85';
  public static FIBRINOLYSIS_ADMINISTERED_OBSERVATION_CODE = '88';
  // 89 & 90
  public static FIRST_CONTACT_WITH_PARAMEDICS_OBSERVATION_CODE = '89';
  // 91 & 92
  public static AMBULANCE_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE = '91';
  // 93 & 94
  public static REGISTRATION_DATE_TIME_OBSERVATION_CODE = '93';
  // 95 & 96
  public static FIRST_HOSPITAL_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE = '95';
  // 97 & 98
  public static QUALIFYING_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE = '97';
  // 99 && 100
  public static FIBRINOLYSIS_GIVEN_DATE_TIME_OBSERVATION_CODE = '99';
  // 101 & 102
  public static FIRST_BALLOON_INFLATION_DEVICE_DATE_TIME_OBSERVATION_CODE = '101';
  public static HEART_TEAM_INVOLVED_IN_TREATMENT_DECISION_OBSERVATION_CODE = '106';
  public static FUNDING_SOURCE_OBSERVATION_CODE = '107';
  public static DART_FROM_OBSERVATION_CODE = '108';
  public static DART_TO_OBSERVATION_CODE = '109';
  public static REMOVAL_REASON_OBSERVATION_CODE = '113';
  public static INTRA_AORTIC_BALLOON_PUMP_OBSERVATION_CODE = '117';
  public static PRESENCE_OF_CORONARY_STENOSIS_OBSERVATION_CODE = '118';
  public static STENOSIS_OF_THE_LEFT_MAIN_ARTERY_OBSERVATION_CODE = '119';
  public static STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE = '120';
  public static STENOSIS_OF_THE_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE = '121';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_OBSERVATION_CODE = '122';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_OBSERVATION_CODE = '123';
  public static STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_124_OBSERVATION_CODE = '124';
  public static STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_125_OBSERVATION_CODE = '125';
  public static STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_126_OBSERVATION_CODE = '126';
  public static STENT_DEPLOYMENT_LOCATION_OBSERVATION_CODE = '127';
  public static LESION_TYPE_OBSERVATION_CODE = '128';
  public static STENT_TYPE_OBSERVATION_CODE = '129';
  public static STENT_SIZE_OBSERVATION_CODE = '130';
  public static STENT_LENGTH_OBSERVATION_CODE = '131';
  public static EXTRACORPOREAL_CARDIOPULMONARY_OBSERVATION_CODE = '134';
  public static VALVE_SURGERY_TYPE_OBSERVATION_CODE = '135';
  public static ATRIAL_FIBRILLATION_ABLATION_TYPE_OBSERVATION_CODE = '136';
  public static ATRIAL_FIBRILLATION_ABLATION_INSTANCE_OBSERVATION_CODE = '137';
  public static CLINICALLY_RELEVANT_PERICARDIAL_EFFUSION_OBSERVATION_CODE = '138';
  public static DEVICE_EMBOLIZATION_OBSERVATION_CODE = '139';
  public static MAJOR_BLEEDING_OBSERVATION_CODE = '140';
  public static NUMBER_OF_VALVE_CLIPS_OBSERVATION_CODE = '141';
  public static POST_OPERATIVE_MITRAL_REGURGITATION_OBSERVATION_CODE = '142';
  public static POST_OPERATIVE_MITRAL_VALVE_GRADIENT_OBSERVATION_CODE = '143';
  public static PERSISTENT_INTER_ATRIAL_SHUNT_POST_PROCEDURE_OBSERVATION_CODE = '144';
  public static TECHNICAL_SUCCESS_OBSERVATION_CODE = '145';
  public static VASCULAR_COMPILATION_OBSERVATION_CODE = '146';
  public static DELAY_REASON_OBSERVATION_CODE = '152';
  public static RACE_OBSERVATION_CODE = '153';
  public static CHRONIC_TOTAL_OCCLUSION_RESULT_OBSERVATION_CODE = '177';
  public static ANATOMY_RESULT_OBSERVATION_CODE = 'calculation-anatomy-result';
  public static CS_OBSERVATION_CODE = 'calculation-cs';
  public static CC_OBSERVATION_CODE = 'calculation-cc';
  public static CI_OBSERVATION_CODE = 'calculation-ci';
  public static CA_OBSERVATION_CODE = 'calculation-ca';
  public static CV_OBSERVATION_CODE = 'calculation-cv';
  public static CM_OBSERVATION_CODE = 'calculation-cm';
  public static CP_OBSERVATION_CODE = 'calculation-cp';
  public static WAIT_TIME_1_DART_DAYS_OBSERVATION_CODE = 'dart-days-wait-time-1';
  public static WAIT_TIME_2_DART_DAYS_OBSERVATION_CODE = 'dart-days-wait-time-2';

  public static PATIENT_REFERRAL_POSTAL_CODE_LINK_ID = 'patient-referral-postal-code';
  public static PATIENT_REFERRAL_POSTAL_CODE_OBSERVATION_CODE = 'prpc';

  public static OBSERVATION_STATUS = 'final';
  public static ENTRY_IDENTIFIER_SYSTEM = 'https://corhealth-ontario.ca/NamingSystem/service-request-id';

  // Identifier systems for ordering Procedures
  public static PROCEDURE_ORDER_IDENTIFIER_SYSTEM = 'https://corhealth-ontario.ca/fhir/NamingSystem/procedure-order-id';
  public static DIAGNOSTIC_REPORT_PROCEDURE_ORDER_IDENTIFIER_SYSTEM =
  'https://corhealth-ontario.ca/fhir/NamingSystem/diagnostic-report-order-id';
  public static OBSERVATION_ORDER_IDENTIFIER_SYSTEM = 'https://corhealth-ontario.ca/fhir/NamingSystem/observation-order-id';

  public static WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM =
  'https://corhealth-ontario.ca/fhir/CodeSystem/WtMetricDataElementObservationCS';
  public static APPOINTMENT_IDENTIFIER_SYSTEM = "https://corhealth-ontario.ca/NamingSystem/appointment-id";
  public static SERVICE_REQUEST_INTENT = 'order';

  // PCR
  public static DSTU2_IDENTIFIER_TYPE_SYSTEM = 'http://hl7.org/fhir/v2/0203'; 
  public static R4_IDENTIFIER_TYPE_SYSTEM = 'http://terminology.hl7.org/CodeSystem/v2-0203';
  public static DSTU2_SECURITY_SYSTEM = 'http://hl7.org/fhir/v3/Confidentiality';
  public static R4_SECURITY_SYSTEM = 'http://terminology.hl7.org/CodeSystem/v3-Confidentiality';
  public static DSTU2_PROFILE_SYSTEM = 'http://ehealthontario.ca/fhir/StructureDefinition/pcr-patient-response|1.0';
  public static R4_PROFILE_SYSTEM = 'https://corhealth-ontario.ca/fhir/StructureDefinition/corhealth-patient';
}
